import { render, staticRenderFns } from "./SelectedFilters.vue?vue&type=template&id=21e74672&scoped=true"
import script from "./SelectedFilters.vue?vue&type=script&lang=js"
export * from "./SelectedFilters.vue?vue&type=script&lang=js"
import style0 from "./SelectedFilters.vue?vue&type=style&index=0&id=21e74672&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e74672",
  null
  
)

export default component.exports